/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import { SHOPY_URL } from "../../models/constants";
import ProductsList from "../../components/products-list";

// const showReactSlider = () => window.innerWidth > 780;
const isDesktop = () => window.innerWidth > 780;

const chocolates = [
  {
    title: "Dulce de leche",
    description: "Base y tapa leche relleno de dulce de leche",
  },
  {
    title: "Fresa",
    description: "Tapa y base amarga relleno de crema de fresas",
  },
  {
    title: "Blanco con Pistacho",
    // description: "Base y tapa amarga relleno timbal de menta y crema de lima",
  },
  {
    title: "Milhojas",
    description: "Finas capas de dulce de leche y chocolate blanco",
  },
  {
    title: "Chocolate en rama",
    description: "",
  },
  {
    title: "Chocolate sin azúcar",
    description: "",
  },
  {
    title: "Chocolate con almendras amargo",
    description: "",
  },
  {
    title: "Suizo",
    description: "Base chocolate con leche, relleno de dulce de leche y nueces tostadas con tapa de chocolate blanco",
  },
  {
    title: "Florentinos",
    description: "Medallones de chocolate amargo con arándanos deshidratados",
  },
];

const arrowStyles = {
  position: "absolute",
  zIndex: 2,
  top: "calc(50% - 15px)",
  width: 30,
  height: 30,
  cursor: "pointer",
  backgroundColor: 'rgba(255,255,255,.5)',
  borderRadius: '50%',
};

const ProductosChocolates = () => {
  const [selectedImage, setSelectedImage] = useState(0);
  const goto = (imageToShow) => {
    setSelectedImage(imageToShow);
  };

  const carousel = (
    <Carousel
      selectedItem={selectedImage}
      width={isDesktop() ? '50%' : '100%'}
      showIndicators={false}
      showThumbs={false}
      infiniteLoop={true}
      showStatus={false}
      showArrows={isDesktop()}
      autoPlay={!isDesktop()}
      onChange={(newValue) => setSelectedImage(newValue)}
      renderArrowPrev={(onClickHandler, hasPrev, label) =>
        hasPrev && (
          <div onClick={onClickHandler}
               className="carrousel-arrow"
               alt=""
               style={{
                 backgroundImage: `url(${
                   require("../../img/left-carrousel-arrow.png").default
                 })`,
                 backgroundSize: "cover",
                 left: 35,
                 marginRight: 35,
                 ...arrowStyles,
               }}
          />
        )
      }
      renderArrowNext={(onClickHandler, hasNext, label) =>
        hasNext && (
          <div
            onClick={onClickHandler}
            className="carrousel-arrow"
            alt=""
            style={{
              backgroundImage: `url(${
                require("../../img/right-carrousel-arrow.png").default
              })`,
              backgroundSize: "cover",
              ...arrowStyles,
              right: 35,
            }}
          />
        )
      }
    >
      <img
        src={require("../../img/productos/chocolates/(1)-Dulce-de-leche.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(2)Frutilla.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(3)-Dupla.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(4)Milhojas.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(5)-Chocolate-en-rama.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(6)-Chocolate-sin-azucar.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(7)-Almendras-amargo.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(8)-Suizo.jpg").default}
        alt="chocolates"
      />
      <img
        src={require("../../img/productos/chocolates/(9)-Florentinos.jpg").default}
        alt="chocolates"
      />
    </Carousel>
  );

  return (
    <div className="productos">
      <div className="top-section">
        <span className="familia-la-pinocha">¿Cuál de todos eliges?</span>
        <span className="conoce-nuestra-historia-1">
          Elaboramos más de 60 sabores diferentes. <br />
          Les mostramos nuestros preferidos
        </span>
      </div>
      <div>
        <div className="productos-rose">
          <ProductsList/>
          <div className="banners">
            {carousel}
          </div>
        </div>
        <div className="white-background">
          <div className="description-chocolate">
            <span className="choco-name mb-3">
              {chocolates[selectedImage].title}
            </span>
            {chocolates[selectedImage].description && (
              <span className="choco-description text-center">
                {chocolates[selectedImage].description}
              </span>
            )}
            {/*<a
              href={SHOPY_URL}
              target="_blank"
              className="margin-queres-conocer footer-submit text-center mt-3"
              rel="noreferrer"
            >
              ¿Queréis conocer más? Descubridlo acá
            </a>*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductosChocolates;
